'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uploadFile;

var _readFileToString = require('../readFileToString');

var _readFileToString2 = _interopRequireDefault(_readFileToString);

var _respToJson = require('../respToJson');

var _respToJson2 = _interopRequireDefault(_respToJson);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Upload file to project Documents
 *
 * @param {File} file File object from upload.
 * @param {string} filename Wanted file name. Default file.name.
 * @return {Promise}
 */
function uploadFile(file, filename) {
    filename = filename || file.name;

    var siteurl = window._spPageContextInfo.webServerRelativeUrl;
    var urlTemplate = siteurl + '/_api/web/lists/getByTitle(\'Documents\')/RootFolder/Files/add(url=\'' + filename + '\',overwrite=\'true\')';
    var requestDigest = document.getElementById('__REQUESTDIGEST');

    return (0, _readFileToString2.default)(file).then(function (filedata) {
        return fetch(urlTemplate, {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Accept': 'application/json;odata=verbose',
                'Content-Type': 'application/json;odata=verbose',
                'Content-Length': filedata.length,
                'X-RequestDigest': requestDigest && requestDigest.value || '',
                'binaryStringRequestBody': 'true'
            },
            body: filedata
        });
    }).then(_respToJson2.default);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/uploadFile.js
// module id = 677
// module chunks = 0